import { Box, Flex } from '@chakra-ui/react';
import { animate, motion, useMotionValue, useTransform } from 'framer-motion';
import { useEffect } from 'react';

import { TextBold, TextRegular } from 'UiKit/typography';
import SkeletonComponent from 'UiKit/skeleton';
import formatCurrency from 'Helper/formatCurrency';
import { Condition } from 'Component/others';

import styles from './styles.module.css';

const OverviewNumbers = ({ title, count, uom = '', uomPosition = 'left', isCurrency, isLoading, bgColor, valueColor }) => {
  const duration = 2;
  const countProgress = useMotionValue(0);
  const rounded = useTransform(() => (isCurrency ? formatCurrency(Math.round(countProgress.get())) : Math.round(countProgress.get())));

  const leftUom = uom && uomPosition === 'left' ? uom : '';
  const rightUom = uom && uomPosition === 'right' ? uom : '';

  useEffect(() => {
    if (!isLoading) {
      const controls = animate(countProgress, parseInt(count), { duration: duration });
      return () => controls.stop();
    }
  }, [countProgress, duration, count, isLoading]);

  return (
    <Box className={styles['overview-numbers__container']}>
      <Flex className={styles['overview-numbers__title-container']}>
        <TextRegular className={styles['overview-numbers__title-text']}>{title}</TextRegular>
      </Flex>

      <Condition statement={!isLoading} fallback={<SkeletonComponent height="20px" width="36px" />}>
        <Flex justifyContent="space-between" alignItems="center">
          <Box
            className={styles['overview-numbers__count']}
            backgroundColor={bgColor}
            color={valueColor}
            minWidth={bgColor && '24px'}
            padding={bgColor && '1px 6px'}
          >
            <Condition statement={leftUom}>
              <TextBold className={styles['overview-numbers__count-uom']}>{leftUom}</TextBold>
            </Condition>
            <motion.pre className={styles['overview-numbers__count-text']}>{rounded}</motion.pre>
            <Condition statement={rightUom}>
              <TextBold className={styles['overview-numbers__count-uom']}>{rightUom}</TextBold>
            </Condition>
          </Box>
        </Flex>
      </Condition>
    </Box>
  );
};

export default OverviewNumbers;
